// src/helpers/rutaCajas.js
import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";
const PABLO_EMAIL = "pablonsaya@hotmail.com";

// -----------------------------
// Auth/token helper
// -----------------------------
function authHeaders() {
  const token = localStorage.getItem("token") || "";
  return { headers: { token } };
}

// -----------------------------
// API calls
// -----------------------------

// ✅ GET: Traer todas las cajas (backend ya filtra por visibilidad)
export const getCajas = async () => {
  const url = `${BASE_URL}/cajas`;
  try {
    const resp = await axios.get(url, authHeaders());
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener cajas",
    };
  }
};

// ✅ GET: Traer una caja por ID
export const getCajaById = async (id) => {
  const url = `${BASE_URL}/cajas/${id}`;
  try {
    const resp = await axios.get(url, authHeaders());
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener caja",
    };
  }
};

// ✅ POST: Crear caja (pública o privada)
export const postCaja = async (cajaData) => {
  const url = `${BASE_URL}/cajas`;
  try {
    const resp = await axios.post(url, cajaData, {
      ...authHeaders(),
      headers: { ...authHeaders().headers, "Content-Type": "application/json" },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear caja",
    };
  }
};

// ✅ PUT: Actualizar caja
export const putCaja = async (id, cajaData) => {
  const url = `${BASE_URL}/cajas/${id}`;
  try {
    const resp = await axios.put(url, cajaData, {
      ...authHeaders(),
      headers: { ...authHeaders().headers, "Content-Type": "application/json" },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar caja",
    };
  }
};

// ✅ DELETE: Desactivar caja
export const deleteCaja = async (id) => {
  const url = `${BASE_URL}/cajas/${id}`;
  try {
    const resp = await axios.delete(url, authHeaders());
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar caja",
    };
  }
};

// -----------------------------
// Utils de visibilidad (front)
// Doble seguro: si el front no conoce el user, confía en backend.
// -----------------------------
export function currentUser() {
  // tolera diferentes claves y JSON roto
  try {
    const raw =
      localStorage.getItem("usuario") ||
      localStorage.getItem("user") ||
      localStorage.getItem("currentUser");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isUserPablo(user) {
  const email = (user?.email || "").toString().trim().toLowerCase();
  return email === PABLO_EMAIL;
}

function toId(val) {
  if (!val) return null;
  if (typeof val === "string") return val;
  if (typeof val === "object") {
    if (val._id) return String(val._id);
    if (val.$oid) return String(val.$oid);
  }
  return null;
}

/**
 * Regla de visibilidad (front):
 * - Si NO hay usuario (null/ilegible) => true (no ocultes lo que ya filtró el backend)
 * - Si hay usuario:
 *    - “Caja Pablo” (por nombre exacto): solo Pablo
 *    - Públicas: todos
 *    - Privadas: Pablo o dueño
 */
export function canSeeCaja(caja, user) {
  if (!caja) return false;

  // sin user legible en el front → no filtramos adicionalmente
  if (!user) return true;

  // guardia por nombre exacto (defensa adicional)
  const esCajaPabloPorNombre =
    (caja.descripcion || "").trim().toLowerCase() === "caja pablo";
  if (esCajaPabloPorNombre && !isUserPablo(user)) return false;

  const isPrivate =
    String(caja.isPrivate) === "true" || caja.isPrivate === true;

  if (!isPrivate) return true;          // públicas → visibles
  if (isUserPablo(user)) return true;   // Pablo ve privadas

  const ownerId = toId(caja.ownerUser);
  const userId =
    toId(user?._id) || toId(user?.id) || toId(user); // tolerante
  return !!ownerId && !!userId && ownerId === userId;
}
